import axios from 'axios'

// axios.interceptors.request.use(config => {
//   if (config.method == 'post') {
//     config.data = {
//       ...config.data,
//       _t: Date.parse(new Date()) / 1000
//     }
//   } else if (config.method == 'get') {
//     config.params = {
//       _t: Date.parse(new Date()) / 1000,
//       ...config.params
//     }
//   }
//   return config
// })

// 保存广告算法设置
export function saveData (params) {
  return axios.post(`/iad_configcentersystemadset/SaveData?_t=${new Date().getTime()}`, params).then(res => {
    return res.data
  })
}

// 获取广告算法设置
export function initData (params) {
  params = params || "";
  return axios.post(`/iad_configcentersystemadset/InitData?_t=${new Date().getTime()}`,params).then(res => {
    return res.data
  })
}



// WEBPACK FOOTER //
// ./src/api/adSetting.js